<template>
  <div>
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-alert
            class="alert"
            :show="dismissCountDown"
            dismissible
            fade
            :variant="alertVariant"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged">
            <p>{{ alertMsj }}</p>
          </b-alert>

          <b-form>
            <app-banco-cuenta
              label="Cuenta"
              :nombre="bancoCuentaNombre"
              :lista="bancosCuentasList"
              :labelCols="labelCols"
              :valido="bancoCuentaValida"
              :msjInvalido="bancoCuentaInvalidaMsj"
              @updated="bancoCuentaActualizada">
            </app-banco-cuenta>

            <b-form-group
              label="Fecha Acreditación"
              label-for="fechaCreditoDebito"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaCreditoDebito" 
                v-model="fechaCreditoDebito" 
                type="date">
              </b-form-input>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import BancoCuenta from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  name: 'ChequesTercerosDepositoBanco',
  props: {
    chequeTerceroId: {
      type: Number,
      default: 0
    }
  },
  components: {
    appBancoCuenta: BancoCuenta,
  },
  data () {
    return {
      error: '',

      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,
      loadingProvincias: false,

      noValidar: true,
      bancoCuentaValida: null,
      bancoCuentaInvalidaMsj: '',

      bancosCuentas: [],
      bancosCuentasList: [],

      bancoCuentaNombre: null,
      fechaCreditoDebito: moment(new Date()).format('YYYY-MM-DD'),

      labelCols: 2,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: ''
    }
  },
  created() {
    this.getDatosAdicionales();
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    getDatosAdicionales() {
      const vm = this;

      let params = {
        monedaId: 101
      }
      vm.$store.dispatch('bancoscuentas/getList', params)
        .then(() => {
          vm.bancosCuentas = this.$store.getters['bancoscuentas/list'];
          vm.bancosCuentasList = this.$store.getters['bancoscuentas/selectList'];
        })
        .catch(() => {
          this.alertMsj = "Se produjo un error al recuperar la lista de cuentas bancarias.";
          this.alertVariant = "danger";
          this.alertCountDown = 15;
          this.showAlert();
        });
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      //this.$v.$touch();

      let save = true;

      let bancoCuentaError = true;
      let bancoCuenta = null;
      if (this.bancoCuentaNombre) {
        bancoCuenta = this.getSelected(this.bancosCuentas, this.bancoCuentaNombre);
      }

      if (bancoCuenta) {
        if (bancoCuenta.id != 0){
          bancoCuentaError = false;
        }
      } 
      if (bancoCuentaError) {
        save = false;
        this.bancoCuentaValida = false;
        this.bancoCuentaInvalidaMsj = "Debe seleccionar la cuenta correspondiente."
      }

      if (save) {
        //if (this.$v.$anyError) {
        //  this.displayErrores();
        //} else {
          let params = {
            bancoCuentaId: bancoCuenta.id,
            chequeTerceroId: this.chequeTerceroId,
            fechaCreditoDebito: moment(this.fechaCreditoDebito).format('YYYY-MM-DD') 
          }
          this.showSpinner();
          this.$store.dispatch('bancomovimiento/depositarChequeTerceros', params)
            .then(() => {
              this.$emit('chequeDepositado');
            })
            .catch(error => {
              this.alertMsj = error;
              this.alertVariant = "danger";
              this.alertCountDown = 15;
              this.showAlert();
            })
            .finally(() => this.hideSpinner());
        //} 
      }
    },
    bancoCuentaActualizada(nombre) {
      this.bancoCuentaNombre = nombre;

      if (this.bancoCuentaNombre ) {
        this.bancoCuentaValida = null;
        this.bancoCuentaInvalidaMsj = '';
      }
    },
    goBack() {
      this.$emit('cancel');
    }
  },
  watch: {
    /*
    'provinciaNombre' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loadingProvincias) {
        this.localidadNombre = null;
        this.getLocalidades();
      }
    },
    'condicionFiscalNombre': function(newVal, oldVal) {
      if ( newVal != oldVal) {
        if (newVal) {
          this.condicionFiscalValida = null;
          this.condicionFiscalInvalidaMsj = '';
        }
      }
    },
    */
  },
  /*
  validations: {
    titular: {
      maxLength: maxLength(50)
    },
    titularCuit: {
      maxLength: maxLength(11)
    },
    serie: {
      required,
      maxLength: maxLength(5)
    },
    numero: {
      required,
      numeric
    },
    importe: {
      decimal,
      minValue: minValue(0)
    },
  },  
  */

}
</script>

<style>
</style>
